import styled from "styled-components";
import { Link } from "react-router-dom";

export const ContentBannerUltragazEnergia = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const BannerUltragazEnergia = styled.img`
  border-radius: 8px;
  object-fit: cover;
  width: 300px;
  height: 300px;

  @media (max-width: 768px) {
    width: 100%;
    object-fit: fill;
    height: 350px;
  }
`;

export const LinkBannerUltragazEnergia = styled(Link)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
